import React from "react";
import { Link } from "react-router-dom";
import { buildCategoryPath, findSegmentByCategory, findSegmentBySlug, fispTvCategories } from "../data/noticias";
import fispLogo from "../assets/logo-iniciales-oscuro.png";

const TV_TOPBAR_EMAIL = "marketing@fisp.org.ar";
const TV_TOPBAR_PHONE_LABEL = "+54 9 11-2387-9118";
const TV_TOPBAR_PHONE_HREF = "https://wa.me/5491123879118";

const socialLinks = [
    {
        label: "YouTube",
        href: "https://www.youtube.com/@fisptv",
        tone: "is-youtube",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                <path d="M21 12.2c0 2.7-.3 4.5-.8 5.3-.4.7-1 1.2-1.7 1.4-.8.3-2.9.5-6.5.5s-5.7-.2-6.5-.5c-.7-.2-1.3-.7-1.7-1.4-.5-.8-.8-2.6-.8-5.3s.3-4.5.8-5.3c.4-.7 1-1.2 1.7-1.4.8-.3 2.9-.5 6.5-.5s5.7.2 6.5.5c.7.2 1.3.7 1.7 1.4.5.8.8 2.6.8 5.3Z" />
                <path d="m10 8.8 5.2 3.2-5.2 3.2Z" fill="currentColor" stroke="none" />
            </svg>
        ),
    },
    {
        label: "Spotify",
        href: "https://open.spotify.com/show/5VlWWkUHnHON4PIodMQw79",
        tone: "is-spotify",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                <circle cx="12" cy="12" r="8.5" />
                <path d="M8 10.3c2.8-1 5.7-.9 8.3.2" strokeLinecap="round" />
                <path d="M8.8 13c2.1-.6 4.3-.5 6.2.2" strokeLinecap="round" />
                <path d="M9.5 15.7c1.5-.4 3.1-.3 4.4.2" strokeLinecap="round" />
            </svg>
        ),
    },
    {
        label: "Instagram",
        href: "https://www.instagram.com/fispsalud/",
        tone: "is-instagram",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.2" cy="6.8" r="0.8" fill="currentColor" stroke="none" />
            </svg>
        ),
    },
    {
        label: "TikTok",
        href: "https://www.tiktok.com/@fispsalud",
        tone: "is-tiktok",
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M14.2 4.2v8.8a3.8 3.8 0 1 1-2.9-3.7" />
                <path d="M14.2 4.2c.7 1.8 2.2 3.2 4.2 3.6" />
            </svg>
        ),
    },
];

const navCategories = [
    "Inicio",
    "Desde Adentro",
    "Segunda Opinión",
    ...fispTvCategories.filter((category) => !["Inicio", "Desde Adentro", "Segunda Opinión"].includes(category)),
];

export default function FispTvNavbar({ activeCategory = "Inicio" }) {
    const activeSegment = findSegmentBySlug(activeCategory) || findSegmentByCategory(activeCategory);
    const activeLabel = activeSegment?.label || activeCategory;

    return (
        <>
            <div className="tv-topbar">
                <div className="tv-navbar-shell">
                    <div className="tv-topbar-inner">
                        <div className="tv-topbar-links">
                            <Link to="/educativo">EDUCATIVO</Link>
                            <span aria-hidden="true"></span>
                            <Link to="/servicios">SERVICIOS</Link>
                        </div>

                        <div className="tv-topbar-links">
                            <a href={`mailto:${TV_TOPBAR_EMAIL}`}>{TV_TOPBAR_EMAIL}</a>
                            <span aria-hidden="true"></span>
                            <a href={TV_TOPBAR_PHONE_HREF}>{TV_TOPBAR_PHONE_LABEL}</a>
                        </div>
                    </div>
                </div>
            </div>

            <header className="tv-navbar">
                <div className="tv-navbar-shell">
                    <div className="tv-navbar-top">
                        <div className="tv-brand-group">
                            <Link to="/" className="tv-brand-logo" aria-label="Ir al inicio de FISP">
                                <img src={fispLogo} alt="FISP" />
                            </Link>
                            <span className="tv-brand-separator" aria-hidden="true"></span>
                            <div className="tv-brand-copy">
                                <Link to="/fisp-tv" className="tv-brand-title tv-brand-title-stack">
                                    <span>Fundacion</span>
                                    <span>Iberoamericana de</span>
                                    <span>Salud Publica</span>
                                </Link>
                            </div>
                        </div>

                        <div className="tv-social-links" aria-label="Redes sociales de FISP TV">
                            {socialLinks.map((socialLink) => (
                                <a
                                    key={socialLink.label}
                                    href={socialLink.href}
                                    target="_blank"
                                    rel="noreferrer"
                                    className={`tv-social-link ${socialLink.tone}`}
                                    aria-label={socialLink.label}
                                    title={socialLink.label}
                                >
                                    <span className="tv-social-icon">{socialLink.icon}</span>
                                    <span className="tv-social-label">{socialLink.label}</span>
                                </a>
                            ))}
                        </div>
                    </div>

                    <nav className="tv-category-bar" aria-label="Categorias de FISP TV">
                        {navCategories.map((category) => {
                            const categorySegment = category === "Inicio"
                                ? { slug: "inicio" }
                                : findSegmentByCategory(category);

                            return (
                                <React.Fragment key={category}>
                                    <Link
                                        to={category === "Inicio" ? "/fisp-tv" : buildCategoryPath(category)}
                                        className={`tv-category-link tv-category-link--${categorySegment?.slug || "inicio"} ${category === activeLabel ? "is-active" : ""}`}
                                    >
                                        <span className="tv-category-link-label">{category}</span>
                                    </Link>

                                    {category === "El Nudo" ? <span className="tv-category-row-break tv-category-row-break--after-nudo" aria-hidden="true"></span> : null}
                                </React.Fragment>
                            );
                        })}
                    </nav>
                </div>
            </header>
        </>
    );
}
